import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/crt/materials/')({
  loader: () => {
    throw redirect({
      to: `/crt/materials/materials-list`,
    })
  },
})
